module.exports = __webpack_public_path__ + "img/title5.65f3e19c.png";